import { ExternalLink, Text } from "@clipboard-health/ui-react";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import { Box, Divider, Link, Stack } from "@mui/material";

import { SUPPORT_TELEPHONE, SUPPORT_WEBFORM_URL } from "../ContactCBHInfo/constants";

export function SupportContactInfo() {
  return (
    <Box>
      <Text variant="h2">Contact Support</Text>
      <Divider sx={{ marginY: 3 }} />
      <Stack direction="row" spacing={6} alignItems="center" flexWrap="wrap">
        <Stack direction="row" spacing={2} alignItems="center">
          <PhoneOutlinedIcon fontSize="small" />
          <Text variant="h4">24/7 Support:</Text>
          <Link href={`tel:${SUPPORT_TELEPHONE}`} underline="none">
            {SUPPORT_TELEPHONE}
          </Link>
        </Stack>
        <ExternalLink to={SUPPORT_WEBFORM_URL} underline="none">
          Submit a Request
        </ExternalLink>
      </Stack>
    </Box>
  );
}
